import {DiscountType, ProductFile, ProductFileType, ProductWOItems} from "../../../../types/product";
import React, {Fragment, useCallback} from "react";
import {CartResponse} from "../../../../types/cart";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAuth, useModal} from "../../../../hooks/hooks";
import {createCartAsync} from "../../../../store/cart/cartSlice";
import {ModalType} from "../../../../types/common";
import {numberWithCommas} from "../../../../util/commonFunctions";
import {useTranslation} from "react-i18next";

export function usePurchaseVoucherFunctions() {
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();
    const { openAlertModal, openModal } = useModal();
    const dispatch = useAppDispatch();
    const { t } = useTranslation("productDetail");

    const getDiscountText = useCallback(
        (productItems: ProductWOItems | undefined, quantity: number) => {
            switch (productItems?.discountType) {
                case DiscountType.AMOUNT:
                    return `${numberWithCommas(Math.floor(productItems?.discountValue * quantity))} ${t("unit")}`;
                case DiscountType.PERCENT:
                    return `${numberWithCommas(Math.floor(productItems?.discountValue))}%`;
                default:
                    return "";
            }
        }, [t]);

    const getDetailImageAndVideoComponents = useCallback(
        (files: ProductFile[]) =>
            files.map((file, index) => (
                <Fragment key={`detail-image-${index}`}>
                    {file.type === ProductFileType.IMAGE && <img src={file.url} alt={"상품 상세 이미지"} />}
                    {file.type === ProductFileType.VIDEO && (
                        <video controls={true} autoPlay={true} muted={true} playsInline={true}>
                            <source src={file.url} />
                        </video>
                    )}
                </Fragment>
            )),
        []
    );

    const onClickPurchaseBtn = async (
        e: React.MouseEvent,
        productDetailInfo: ProductWOItems | undefined,
        quantity: number,
    ) => {
        if (isLoggedIn) {
            if (productDetailInfo) {
                try {
                    const carts: CartResponse[] = await dispatch(
                        createCartAsync([
                            {
                                productIdx: productDetailInfo.idx,
                                quantity: quantity,
                            },
                        ])
                    ).unwrap();

                    const cartIdxes = carts.map((it) => it.idx);
                    navigate(`/order?cart-idxes=${cartIdxes}`);
                } catch (error) {
                    console.error(error);
                    openAlertModal(null);
                }
            }
        } else {
            openModal(ModalType.LOGIN);
            e.stopPropagation();
        }
    };

    return{
        getDiscountText,
        getDetailImageAndVideoComponents,
        onClickPurchaseBtn,
    }
}